import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionRenderer from './SectionRenderer';

const DEFAULT_ORDER = ['hero', 'about', 'projects', 'skills', 'experience', 'contact'];

const FramedPortfolioLayout = ({ siteConfig }) => {
  const order = Array.isArray(siteConfig?.sectionOrder) && siteConfig.sectionOrder.length
    ? siteConfig.sectionOrder
    : DEFAULT_ORDER;
  const visibility = siteConfig?.sectionVisibility || {};

  return (
    <div className="theme-layout-framed">
      <div className="theme-frame-shell">
        <Header />
        <main className="theme-framed-main">
          {order.map((sectionKey, index) => {
            if (visibility[sectionKey] === false) {
              return null;
            }

            return (
              <section
                key={sectionKey}
                className={`theme-framed-section ${index % 2 === 0 ? 'theme-framed-section-primary' : 'theme-framed-section-secondary'}`}
              >
                <SectionRenderer sectionKey={sectionKey} />
              </section>
            );
          })}
        </main>
        {visibility.footer !== false && (
          <div className="theme-framed-footer">
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default FramedPortfolioLayout;
